import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { UserColorsDataGrid } from '../../components/datagrid/UserColorsDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { UserColor } from '../../types/userColor.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function UserColors() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'User colors',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error } = useSWR<UserColor[]>(`${API_URL.USER_COLOR_LIST}`, fetcher, swrConfig);

  const handleEditButton = (e): void => {
    history.push(`/user-colors/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <UserColorsDataGrid
        data={data?.map((x) => {
          return {
            ...x,
            id: x.userId,
          };
        })}
        handleEdit={handleEditButton}
      />
    </PageContentWrapper>
  );
}
export default UserColors;
